// src/redux/deviceregisterSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_deviceregister,
  add_deviceregister,
  update_deviceregister,
  delete_deviceregister,
  get_deviceregister_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  deviceregister: [],
  deviceregisterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    serial_number :"",
    command_id :"",
    username :"",
    password :"",
    api_key :"",
    ip :"",
  },
};

// Async Thunks for API Calls
export const fetchdeviceregisterList = createAsyncThunk(
    'deviceregister/fetchdeviceregisterlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_deviceregister_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchdeviceregister = createAsyncThunk(
  "deviceregister/fetchdeviceregister",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_deviceregister(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createdeviceregister = createAsyncThunk(
  "deviceregister/createdeviceregister",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_deviceregister(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatedeviceregister = createAsyncThunk(
  "deviceregister/updatedeviceregister",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_deviceregister(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletedeviceregister = createAsyncThunk(
  "deviceregister/deletedeviceregister",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_deviceregister({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// deviceregister Slice
const deviceregisterSlice = createSlice({
  name: 'deviceregisters',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
  EditFormData(reduxState, action) {
       reduxState.formData = { ...action.payload };
     },
    resetFormData(state) {
      state.formData = {
        name: "",
    serial_number :"",
    command_id :"",
    username :"",
    password :"",
    api_key :"",
    ip :"",
      };
    },
    setdeviceregister(state, action) {
      state.deviceregister = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchdeviceregisterList.fulfilled, (state, action) => {
        state.deviceregisterlist = action.payload.data;
      })
      .addCase(fetchdeviceregisterList.rejected, (state, action) => {
        state.deviceregisterlist = [];
      })
     
       // Fetch deviceregister
       .addCase(fetchdeviceregister.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchdeviceregister.fulfilled, (state, action) => {
        state.loading = false;
        state.deviceregister = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchdeviceregister.rejected, (state, action) => {
        state.loading = false;
        state.deviceregister = [];
        state.error = action.payload;
      })

      // Add deviceregister
      .addCase(createdeviceregister.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createdeviceregister.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createdeviceregister.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update deviceregister
      .addCase(updatedeviceregister.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatedeviceregister.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatedeviceregister.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete deviceregister
      .addCase(deletedeviceregister.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletedeviceregister.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletedeviceregister.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setdeviceregister,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = deviceregisterSlice.actions;
export default deviceregisterSlice.reducer;
